import { Box, Fade, Typography } from '@material-ui/core';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';

const TransitionPaymentHeader = ({
  headingLabel,
  classes,
  fadeIn,
  name,
  clickHandler,
}) => (
  <Box className={classes.boxInnerContainer}>
    <Box>
      <Typography className={classes.heading}>{headingLabel}</Typography>
    </Box>
    <Fade in={!fadeIn}>
      <AddCircleOutlineRoundedIcon
        data-testid={`fade-click-${name}`}
        onClick={() => clickHandler(name)}
        style={{ color: '#e00', cursor: 'pointer' }}
      />
    </Fade>
  </Box>
);

export default TransitionPaymentHeader;
